import _ from 'lodash';
import {
  COLOR_CODES_FOR_CATEGORIES,
  REPORT_COLORS,
  INGSIGHT_360_PROFILE_REPORT_NAME,
  INGSIGHT_360_ATTITUDE_REPORT_NAME,
  INGSIGHT_360_BRANDS_REPORT_NAME,
  INGSIGHT_360_MEDIA_REPORT_NAME,
  INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME,
  INSIGHT_360_PROFILE_LABEL,
  INSIGHT_360_ATTITUDES_LABEL,
  INSIGHT_360_BRANDS_LABEL,
  INSIGHT_360_MEDIA_LABEL,
  INSIGHT_360_DEMO_LABEL,
  INSIGHT_360_REPORT_LABEL,
  INSIGHT_360_HEADER_LABEL,
  INSIGHT_360_ERROR_LABEL,
  INGSIGHT_360_REPORTVIEW_REPORT_NAME,
  INGSIGHT_360_HEADERINFO_REPORT_NAME,
  DEEP_DIVE_REPORT_NAME,
  MRI_TAG_NAME,
  COPY_RIGHT_TEXT,
  PREFERENCE_BRAND_CATALYST,
  PREFERENCE_BRAND_CATALYST_REACH,
  PREFERENCE_BRAND_CATALYST_SAMPLE,
  PREFERENCE_BRAND_CATALYST_INDEX,
  PREFERENCE_STUDY,
  PREFERENCE_BRAND_CATALYST_BASE,
  BRAND_CATALYST_PREFERENCE_KEY_MAPPING,
  DEFAULT_REACH,
  DEFAULT_SAMPLE,
  DEFAULT_INDEX,
  COLOR_CODES_FOR_MRI_CATEGORIES,
  MRI_STUDY_WARNING_TYPE_6,
  MRI_STUDY_WARNING_TYPE_7,
  MRI_STUDY_WARNING_TYPE_8,
  PROFILE_SELF_CONCEPTS,
  MRI_STUDY_NAME_FLAG,
  SAMPLE_SIZE_RESTRICTION,
  BRAND_CATALYST_FEATUREID,
  PREFERENCE_BRAND_CATALYST_BRAND_FILTER_LIST,
  PREFERENCE_BRAND_CATALYST_MEDIA_FILTER_LIST,
  INSIGHT360_EXPLORE,
  SECTION_SORT_BY_ATTITUDES,
  SECTION_SORT_BY_BRANDS,
  SECTION_SORT_BY_MEDIA,
  SECTION_SORT_BY_PROFILE,
  SECTION_SORT_BY_DEMOS,
} from '../constants';
import {
  // attitudes,
  mediaBrands,
 // demographics,
  // profiles,
  simmonsAttitudes,
  mriAttitudes,
  simmonsDemographics,
  mriDemographics,
  mriProfiles,
  simmonsProfiles,
} from '../components/insights360/json/emptyResponse';
import { numberWithCommas, formatIndexRangeFilter, getStudyFromStudies, filterStudyList } from './CommonUtils';
import * as urls from '../actions/urlTypes';
import { setPreferenceFlag } from '../actions/preferencesActions';
import { set360Study, setBrandCatalystPreferenceData } from '../actions/insight360Actions';

export const getHighestIndexOrPercent = (attitudeList, selectedOption) => {
  let highestVal = 0;
  _.forEach(attitudeList, val => {
    if (val.data !== undefined) {
      const currentVal = val.data.value[selectedOption];
      if (currentVal > highestVal) {
        highestVal = currentVal;
      }
    }
  });
  return highestVal;
};

export const getHighestIndexOrPercentBrands = (
  attitudeList,
  selectedOption,
) => {
  let highestVal = 0;
  _.forEach(attitudeList, val => {
    const currentVal = val[selectedOption];
    if (currentVal > highestVal) {
      highestVal = currentVal;
    }
  });
  return highestVal;
};

export const calculateMRIAsterisk = (sample, warningType) => {
  if (warningType === MRI_STUDY_WARNING_TYPE_6 && sample < 50) {
    return '*';
  } if (warningType === MRI_STUDY_WARNING_TYPE_7) {
    if (sample < 25) {
      return '**';
    } if (sample < 50) {
      return '*';
    }
  } else if (warningType === MRI_STUDY_WARNING_TYPE_8) {
    if (sample < 31) {
      return '**';
    } if (sample < 60) {
      return '*';
    }
  }
  return '';
};

export const calculateAsterisk = sample => {
  if (sample < 31) {
    return '**';
  }
  if (sample < 61) {
    return '*';
  }
  return '';
};

export const processData = (reportsData, updateAsteriskStatus, sortInfo, studyInfo) => {
  const categories = [];
  const personas = [];
  const graphSeriesData = [];
  const selectedIndex = reportsData.selectedIndex;
  const sortIndexInfo = [];
  let sortedInfo = [];
  const selectedSeriesList = reportsData.selectedSeries;
  const isMRISpecificStudy = studyInfo.ss.includes('MRI');
  const warningType = studyInfo.wnt;
  if (selectedSeriesList.length > 0) {
    const originalReportResponse = _.cloneDeep(reportsData.rawData);
    const selectedSeries = reportsData.selectedSeries;
    const filteredDetailedGroups = [];

    originalReportResponse.forEach((item, index) => {
      filteredDetailedGroups[index] = originalReportResponse[index].detailGroups.filter(detailItem =>
        selectedSeries.find(selectedItem => {
          if (selectedItem.isChecked) {
            if (detailItem.label === selectedItem.label) {
              return true;
            }
          } else {
            return false;
          }
          return false;
        })
      );
    });

    originalReportResponse.forEach((item, index) => {
      item.detailGroups = filteredDetailedGroups[index];
    });
    reportsData.rawData = originalReportResponse;
  }

  if (sortInfo.index !== undefined) {
    _.forEach(reportsData.rawData[sortInfo.index].detailGroups, data => {
      sortIndexInfo.push({
        label: data.label,
        value:
        reportsData.selectedIndex === 'Index'
            ? data.value.index
            : _.toNumber(data.value.pct.replace('%', '')),
      });
    });
    sortedInfo = _.orderBy(sortIndexInfo, ['value'], [`${sortInfo.type}`]);
    _.forEach(sortedInfo, data => {
      categories.push(data.label);
    });
  } else {
    _.forEach(reportsData.rawData[0].detailGroups, data => {
      categories.push(data.label);
    });
  }

  _.forEach(reportsData.rawData, data => {
    personas.push(data.label);
  });

  _.forEach(personas, (persona, i) => {
    const graphData = {};
    graphData.name = persona;
    graphData.data = [];
    _.forEach(categories, category => {
      const cat = _.find(reportsData.rawData[i].detailGroups, {
        label: category,
      });
      if (cat) {
        graphData.data.push({
          y:
            selectedIndex === 'Index'
              ? cat.value.index
              : _.toNumber(cat.value.pct.replace('%', '')),
          asterik: isMRISpecificStudy ? calculateMRIAsterisk(cat.value.sample, warningType) :
            calculateAsterisk(cat.value.sample),
          weighted: numberWithCommas(
            Math.round(cat.value.weighted),
          ),
          sample: numberWithCommas(
            Math.round(cat.value.sample),
          ),
          reach: cat.value.pct,
          indexVal: cat.value.index,
        });
      }
      // graphData.asterik.push(calculateAsterisk(cat.value.sample));
    });
    /* graphData.tooltip = {formatter: function() {
        return (selectedIndex === 'Index' ? '' : '%') + this.point.asterik
      }
    } */
    graphSeriesData.push(graphData);
  });
  const totalDataPoints = categories.length * personas.length * 25;
  const height = totalDataPoints <= 400 ? '400px' : totalDataPoints;
  const config = {
    chart: {
      type: 'bar',
      height,
      spacingRight: 20,
    },
    annotations: [
      {
        labelOptions: {
          allowOverlap: true,
        },
      },
    ],
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    colors: REPORT_COLORS,
    xAxis: {
      categories,
      title: {
        text: null,
      },
      scrollbar: {
        enabled: true,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: reportsData.selectedIndex,
        align: 'high',
      },
      labels: {
        overflow: 'justify',
      },
      opposite: true,
    },
    /* tooltip: {
      valueSuffix: selectedIndex === 'Index' ? '' : '%',
    }, */
    tooltip: {
      borderRadius: 15,
      borderColor: 'rgb(212, 216, 221)',
      backgroundColor: '#fff',
      style: {
        fontSize: '11px',
      },
      formatter() {
        return `SAMPLE: <b>${this.point.sample}</b>
          <br/>WEIGHTED: <b>${this.point.weighted}</b><br/>${selectedIndex !== 'Index' ? `INDEX: 
          <b>${this.point.indexVal}</b>` : `REACH: <b>${this.point.reach}</b>`}`;
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: 'none',
          allowOverlap: true,
          formatter() {
            const pctOrIndex = selectedIndex === 'Index' ? '' : '%';
            return ` ${this.point.asterik} ${this.y}${pctOrIndex}`;
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    series: graphSeriesData,
  };
  return config;
};

export const getColorCodeForGivenCategory = (category, studyName) => {
  const colorCategories =
 studyName === MRI_STUDY_NAME_FLAG ? COLOR_CODES_FOR_MRI_CATEGORIES :
 COLOR_CODES_FOR_CATEGORIES;
  const colorObj = _.find(colorCategories, category);
  return colorObj !== undefined
    ? colorObj[category]
    : _.values(colorCategories[0])[0];
};

export const checkAsterickFormate = (
  data,
  isDoubleAsterisk,
  isSingleAsterisk,
) => {
  if (isDoubleAsterisk) {
    return `** ${data}`;
  } if (isSingleAsterisk) {
    return `* ${data}`;
  }
  return data;
};

export const getBoldLabelText = text => {
  const arrayVal = text.split('(');
  return arrayVal[0];
};

export const getNormalLabelText = text => {
  if (
    text === 'N/A' ||
    text === 'NA' ||
    text === undefined ||
    text === '' ||
    text === null
  ) {
    return '';
  }
  let arrayVal = text.split('(');
  arrayVal.splice(0, 1);
  if (arrayVal.length > 0) {
    arrayVal = arrayVal.join('(');
    return `(${arrayVal}`;
  }
  return '';
};

export const handleEmptyResponse = (config, studySource) => {
  const data = [];
  let emptyData = {};
  switch (config.reportName) {
    case '360PROF':
      emptyData = studySource === MRI_STUDY_NAME_FLAG ? mriProfiles : simmonsProfiles;
      break;
    case '360ATT':
      emptyData = studySource === MRI_STUDY_NAME_FLAG ? mriAttitudes : simmonsAttitudes;
      break;
    case '360BRANDS':
      emptyData = mediaBrands;
      break;
    case '360MEDIA':
      emptyData = mediaBrands;
      break;
    case '360DEMOS':
      emptyData = studySource === MRI_STUDY_NAME_FLAG ? mriDemographics : simmonsDemographics;
      break;
    default:
      emptyData = {};
      break;
  }

  for (let i = 0; i < config.personaLabels.length; i += 1) {
    data.push(emptyData);
  }

  return data;
};

export const getErrorCategoryLabel = reportName => {
  let errorCategory = '';
  switch (reportName) {
    case INGSIGHT_360_PROFILE_REPORT_NAME:
      errorCategory = INSIGHT_360_PROFILE_LABEL;
      break;
    case INGSIGHT_360_ATTITUDE_REPORT_NAME:
      errorCategory = INSIGHT_360_ATTITUDES_LABEL;
      break;
    case INGSIGHT_360_BRANDS_REPORT_NAME:
      errorCategory = INSIGHT_360_BRANDS_LABEL;
      break;
    case INGSIGHT_360_MEDIA_REPORT_NAME:
      errorCategory = INSIGHT_360_MEDIA_LABEL;
      break;
    case INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME:
      errorCategory = INSIGHT_360_DEMO_LABEL;
      break;
    case INGSIGHT_360_REPORTVIEW_REPORT_NAME:
      errorCategory = INSIGHT_360_REPORT_LABEL;
      break;
    case INGSIGHT_360_HEADERINFO_REPORT_NAME:
      errorCategory = INSIGHT_360_HEADER_LABEL;
      break;
    default:
      errorCategory = INSIGHT_360_ERROR_LABEL;
      break;
  }
  return errorCategory;
};

export const getCopyRightDiv = () => {
  const copyRightDiv = document.createElement('div');
  copyRightDiv.setAttribute('class', 'copyRightDivCss');
  copyRightDiv.innerHTML = `${MRI_TAG_NAME}, ${urls.CURRENT_YEAR}. ${COPY_RIGHT_TEXT}`;
  return copyRightDiv;
};

export const downloadWholePdf = (downloadReport, props) => {
  const reportHeader = document.getElementById('personaHeader');
  const cloneReportHeader = reportHeader.cloneNode(true);
  downloadReport.setAttribute('class', 'exportPdf');
  const pcSecondHeaderDiv = document.getElementById('pdfCreatorHeader');
  const studyInfo = document.getElementById('studyInfo');

  const cardHeaderDiv = document.createElement('div');
  cardHeaderDiv.innerHTML = '&nbsp;';

  // attitude
  const attitudeGrid = document.getElementById('attitudePersonaGrid');
  if (attitudeGrid !== null) {
    // header ...
    const profile = document.getElementById('profilePersonaGrid');
    const profileTopBrands = profile.querySelector('#profileTopBrands');

    if (profileTopBrands !== null) {
      const attitudePageBreak = document.createElement('div');
      attitudePageBreak.setAttribute('class', 'html2pdf__page-break');
      downloadReport.append(attitudePageBreak);
    }
    if (props.selectedTab !== 'CREATOR') {
      downloadReport.append(cardHeaderDiv);
    }

    if (props.selectedTab === 'CREATOR') {
      const clonePcSecondHeaderDiv = pcSecondHeaderDiv.cloneNode(true);
      downloadReport.append(clonePcSecondHeaderDiv);
      clonePcSecondHeaderDiv.setAttribute('class', 'creatorPdf');
    }

    downloadReport.append(cloneReportHeader);
    if (props.selectedTab !== 'CREATOR') {
      const cardAttitudeBlankDiv = document.createElement('div');
      cardAttitudeBlankDiv.setAttribute('class', 'explore_attitude_pdf_blank_div');
      // cardAttitudeBlankDiv.innerHTML = '&nbsp;';
      downloadReport.append(cardAttitudeBlankDiv);
    }

    const attitudeGridClone = attitudeGrid.cloneNode(true);
    attitudeGridClone.setAttribute('class', 'brandsPdfStyle');
    downloadReport.append(attitudeGridClone);
    const cloneAtitudeStudyInfo = studyInfo.cloneNode(true);
    downloadReport.append(cloneAtitudeStudyInfo);
    const attitudeCopyRightInfo = getCopyRightDiv();
    downloadReport.append(attitudeCopyRightInfo);
  }

  // brand...
  const grid = document.getElementById('brandsPersonaGrid');
  if (grid !== null) {
    const brandsPageBreak = document.createElement('div');
    brandsPageBreak.setAttribute('class', 'html2pdf__page-break');
    downloadReport.append(brandsPageBreak);

    const cardBrandHeaderDiv = document.createElement('div');
    cardBrandHeaderDiv.innerHTML = '&nbsp;';
    if (props.selectedTab !== 'CREATOR') {
      downloadReport.append(cardBrandHeaderDiv);
    }

    if (props.selectedTab === 'CREATOR') {
      const clonePcBrandsSecondHeaderDiv = pcSecondHeaderDiv.cloneNode(true);
      downloadReport.append(clonePcBrandsSecondHeaderDiv);
      clonePcBrandsSecondHeaderDiv.setAttribute('class', 'creatorPdf');
    }

    const cloneBrandReportHeader = reportHeader.cloneNode(true);
    downloadReport.append(cloneBrandReportHeader);

    const gridClone = grid.cloneNode(true);
    gridClone.setAttribute('class', 'brandsPdfStyle');
    downloadReport.append(gridClone);
    const cloneBrandsStudyInfo = studyInfo.cloneNode(true);
    downloadReport.append(cloneBrandsStudyInfo);
    const brandCopyRightInfo = getCopyRightDiv();
    downloadReport.append(brandCopyRightInfo);
    // downloadReport.appendChild(cloneStudyInfo);
  }

  // media..
  const mediaGrid = document.getElementById('mediaPersonaGrid');
  if (mediaGrid !== null) {
    const mediaPageBreak = document.createElement('div');
    mediaPageBreak.setAttribute('class', 'html2pdf__page-break');
    downloadReport.append(mediaPageBreak);

    if (props.selectedTab !== 'CREATOR') {
      const cardBrandHeaderDiv = document.createElement('div');
      cardBrandHeaderDiv.innerHTML = '&nbsp;';
      downloadReport.append(cardBrandHeaderDiv);
    }

    if (props.selectedTab === 'CREATOR') {
      const clonePcMediaSecondHeaderDiv = pcSecondHeaderDiv.cloneNode(true);
      downloadReport.append(clonePcMediaSecondHeaderDiv);
      clonePcMediaSecondHeaderDiv.setAttribute('class', 'creatorPdf');
    }

    const cloneMediaReportHeader = reportHeader.cloneNode(true);
    downloadReport.append(cloneMediaReportHeader);

    const mediaGridClone = mediaGrid.cloneNode(true);
    mediaGridClone.setAttribute('class', 'brandsPdfStyle');
    downloadReport.append(mediaGridClone);
    const cloneMediaStudyInfo = studyInfo.cloneNode(true);
    downloadReport.append(cloneMediaStudyInfo);
    const mediaCopyRightInfo = getCopyRightDiv();
    downloadReport.append(mediaCopyRightInfo);
  }

  // demographics..
  const demoGrid = document.getElementById('demographicsPersonaGrid');
  if (demoGrid !== null) {
    const demoPageBreak = document.createElement('div');
    demoPageBreak.setAttribute('class', 'html2pdf__page-break');
    downloadReport.append(demoPageBreak);

    if (props.selectedTab !== 'CREATOR') {
      const cardDemoHeaderDiv = document.createElement('div');
      cardDemoHeaderDiv.innerHTML = '&nbsp;';
      downloadReport.append(cardDemoHeaderDiv);
      // let demoFilter= document.createElement('div')
    }

    if (props.selectedTab === 'CREATOR') {
      const clonePcDemoSecondHeaderDiv = pcSecondHeaderDiv.cloneNode(true);
      downloadReport.append(clonePcDemoSecondHeaderDiv);
      clonePcDemoSecondHeaderDiv.setAttribute('class', 'creatorPdf');
    }

    const cloneDemoReportHeader = reportHeader.cloneNode(true);
    downloadReport.append(cloneDemoReportHeader);

    const demoGridClone = demoGrid.cloneNode(true);
    demoGridClone.setAttribute('class', 'brandsPdfStyle');
    downloadReport.append(demoGridClone);
    const cloneDemoStudyInfo = studyInfo.cloneNode(true);
    downloadReport.append(cloneDemoStudyInfo);
    const DemocopyRightDiv = getCopyRightDiv();
    downloadReport.append(DemocopyRightDiv);
  }

  return downloadReport;
};

export const pdfFormat = (headerId, cardId, props) => {
  let downloadReport = document.createElement('div');
  const blankDiv = document.createElement('div');
  blankDiv.innerHTML = '&nbsp;';
  const cloneBlankDiv = blankDiv.cloneNode(true);
  cloneBlankDiv.setAttribute('class', 'blankDiv');

  if (props.selectedTab !== 'CREATOR') {
    downloadReport.append(blankDiv);
  }

   // adding notable section..
  const notableSection = document.getElementById('notablePersonaGrid');
  if ((notableSection !== null && notableSection !== undefined) && props.selectedTab === 'CREATOR') {
   // adding main creator header
    const pcNotableHeaderDiv = document.getElementById('pdfCreatorHeader');
    const clonePcNotableHeaderDiv = pcNotableHeaderDiv.cloneNode(true);
    clonePcNotableHeaderDiv.setAttribute('class', 'creatorPdf');
    downloadReport.append(clonePcNotableHeaderDiv);

     // second creator header..
    if (headerId !== null && headerId !== undefined && headerId !== '') {
      const NotableSecondHeader = document.getElementById(headerId);
      const cloneNotableSecondHeader = NotableSecondHeader.cloneNode(true);
      downloadReport.append(cloneNotableSecondHeader);
      downloadReport.setAttribute('class', 'exportPdf');
      const notableCardHeaderDiv = document.createElement('div');
      notableCardHeaderDiv.setAttribute('class', 'blankDiv');
      notableCardHeaderDiv.innerHTML = '&nbsp;';
      downloadReport.append(notableCardHeaderDiv);

      // adding notable section in pdf..
      const notableSectionClone = notableSection.cloneNode(true);
      notableSectionClone.setAttribute('class', 'brandsPdfStyle');
      downloadReport.append(notableSectionClone);
      const notableStudyInfo = document.getElementById('studyInfo');
      const cloneNotableStudyInfo = notableStudyInfo.cloneNode(true);
      downloadReport.append(cloneNotableStudyInfo);
      const notableCopyRightDiv = getCopyRightDiv();
      downloadReport.append(notableCopyRightDiv);

      const natablePageBreak = document.createElement('div');
      natablePageBreak.setAttribute('class', 'html2pdf__page-break');
      downloadReport.append(natablePageBreak);
    }
  }


  // adding source info div...
  const studyInfo = document.getElementById('studyInfo');
  const cloneStudyInfo = studyInfo.cloneNode(true);
  const cloneStudyInfoOne = studyInfo.cloneNode(true);
  const cloneStudyInfoTwo = studyInfo.cloneNode(true);

  if (props.selectedTab === 'CREATOR') {
    const pcHeaderDiv = document.getElementById('pdfCreatorHeader');
    const clonePcHeaderDiv = pcHeaderDiv.cloneNode(true);
    clonePcHeaderDiv.setAttribute('class', 'creatorPdf');
    downloadReport.append(clonePcHeaderDiv);
  }

  if (headerId !== null && headerId !== undefined && headerId !== '') {
    const reportHeader = document.getElementById(headerId);
    const cloneReportHeader = reportHeader.cloneNode(true);
    downloadReport.append(cloneReportHeader);
    downloadReport.setAttribute('class', 'exportPdf');

    const cardHeaderDiv = document.createElement('div');
    cardHeaderDiv.setAttribute('class', 'blankDiv');
    cardHeaderDiv.innerHTML = '&nbsp;';
    downloadReport.append(cardHeaderDiv);
  }

  if (cardId === 'profilePersonaGrid' || cardId === 'wholePersonaPdf') {
    let profile = '';
    if (cardId === 'wholePersonaPdf') {
      profile = document.getElementById('profilePersonaGrid');
    } else {
      profile = document.getElementById(cardId);
    }
    const profilePersonaFirstSection = profile.querySelector(
      '#profilePersonaFirstSection',
    );
    // adding sections of profile in pdf...
    const profileTopBrands = profile.querySelector('#profileTopBrands');
    const profileTopMedia = profile.querySelector('#profileTopMedia');

    const gridFirstSectClone = profilePersonaFirstSection.cloneNode(true);
    downloadReport.append(gridFirstSectClone);
    downloadReport.appendChild(cloneStudyInfo);
    const profileFirstCopyRightDiv = getCopyRightDiv();
    downloadReport.append(profileFirstCopyRightDiv);

    downloadReport.setAttribute('class', 'exportPdf');

    const pageBreak = document.createElement('div');
    pageBreak.setAttribute('class', 'html2pdf__page-break');
    downloadReport.append(pageBreak);

    // profile pdf double and triple pdf...
    if (profileTopBrands !== null && profileTopMedia !== null) {
      // profile second sect...
      const cloneBlankSecondSection = blankDiv.cloneNode(true);
      if (props.selectedTab !== 'CREATOR') {
        downloadReport.append(cloneBlankSecondSection);
      }
      if (props.selectedTab === 'CREATOR') {
        const pcSecondHeaderDiv = document.getElementById('pdfCreatorHeader');
        const clonePcSecondHeaderDiv = pcSecondHeaderDiv.cloneNode(true);
        clonePcSecondHeaderDiv.setAttribute('class', 'creatorPdf');
        downloadReport.append(clonePcSecondHeaderDiv);
      }

      const reportHeader = document.getElementById(headerId);
      const cloneReportHeader = reportHeader.cloneNode(true);
      downloadReport.append(cloneReportHeader);
      // downloadReport.append(cloneReportSecondHeader);

      const brandHeader = document.createElement('div');
      brandHeader.innerHTML = 'TOP 5 BRANDS';
      brandHeader.setAttribute('class', 'profile-comparasion-top-header');
      downloadReport.append(brandHeader);
      const cloneProfileBrand = profileTopBrands.cloneNode(true);
      downloadReport.append(cloneProfileBrand);
      downloadReport.appendChild(cloneStudyInfoOne);

      const profileSecondSectionCopyRightDiv = getCopyRightDiv();
      downloadReport.append(profileSecondSectionCopyRightDiv);


      const pageBreak2 = document.createElement('div');
      pageBreak2.setAttribute('class', 'html2pdf__page-break');
      downloadReport.append(pageBreak2);

      // // profile third sect...
      if (props.selectedTab !== 'CREATOR') {
        downloadReport.append(cloneBlankDiv);
      }
      if (props.selectedTab === 'CREATOR') {
        const pcSecondHeaderDiv = document.getElementById('pdfCreatorHeader');
        const clonePcSecondHeaderDiv = pcSecondHeaderDiv.cloneNode(true);
        clonePcSecondHeaderDiv.setAttribute('class', 'creatorPdf');
        downloadReport.append(clonePcSecondHeaderDiv);
      }
      const cloneReportSecondHeader = reportHeader.cloneNode(true);
      downloadReport.append(cloneReportSecondHeader);

      const mediaHeader = document.createElement('div');
      mediaHeader.innerHTML = 'TOP 5 MEDIA';
      mediaHeader.setAttribute('class', 'profile-comparasion-top-header');
      downloadReport.append(mediaHeader);
      const cloneProfileMedia = profileTopMedia.cloneNode(true);
      downloadReport.append(cloneProfileMedia);
      downloadReport.appendChild(cloneStudyInfoTwo);

      const profileThirdSectionCopyRightDiv = getCopyRightDiv();
      downloadReport.append(profileThirdSectionCopyRightDiv);
    }
  } else {
    if (props.selectedTab === 'CREATOR' && cardId === 'attitudePersonaGrid') {
      const creatorAttitudeBlankDiv = document.createElement('div');
      creatorAttitudeBlankDiv.innerHTML = '&nbsp;';
      creatorAttitudeBlankDiv.setAttribute('class', 'attitudeBlankDiv');
      downloadReport.append(creatorAttitudeBlankDiv);
    }

    if (cardId !== 'wholePersonaPdf') {
      const grid = document.getElementById(cardId);
      const gridClone = grid.cloneNode(true);
      gridClone.setAttribute('class', 'brandsPdfStyle');
      downloadReport.append(gridClone);
      downloadReport.appendChild(cloneStudyInfo);
    }
  }

  if (cardId === 'wholePersonaPdf') {
    downloadReport = downloadWholePdf(downloadReport, props);
  }

  return downloadReport;
};

export const reportPdfFormat = () => {
  const downloadReport = document.createElement('div');
  const reportChartHeader = document.getElementById('reportHeader');
  const cloneReportChartHeader = reportChartHeader.cloneNode(true);
  // downloadReport.setAttribute('class', 'exportPdf');
  downloadReport.append(cloneReportChartHeader);

  const reportGraphHeading = document.getElementById('reportGraphHeading');
  const cloneReportGraphHeading = reportGraphHeading.cloneNode(true);
  downloadReport.append(cloneReportGraphHeading);

  const reportChart = document.getElementById('pdfReportChart');
  const cloneReportChart = reportChart.cloneNode(true);
  downloadReport.setAttribute('class', 'reportPdf');
  downloadReport.append(cloneReportChart);
  return downloadReport;
};

export const getDeepDiveReportName = section => {
  const reportObj = _.find(DEEP_DIVE_REPORT_NAME, section);
  return reportObj !== undefined
    ? reportObj[section]
    : '';
};

export const getAttitudeChoiceLevel = (attitudeChoice, attitudeChoiceLevelData) => {
  let selectedLevel = 0;
  if (attitudeChoiceLevelData.length > 0) {
    selectedLevel = _.findIndex(attitudeChoiceLevelData, attitudeChoice);
    return selectedLevel;
  }
  return selectedLevel;
};

export const processDataForDeepDive = (reportsData, updateAsteriskStatus, sortInfo, studyInfo) => {
  const categories = [];
  const personas = [];
  const graphSeriesData = [];
  const isMRISpecificStudy = studyInfo.ss.includes('MRI');
  const warningType = studyInfo.wnt;
  // const selectedIndex = reportName === INSIGHT_360_DEMO_LABEL ? 'pct' : reportsData.selectedIndex;
  const selectedIndex = reportsData.selectedIndex;
  const sortIndexInfo = [];
  let sortedInfo = [];
  if (sortInfo.index !== undefined) {
    _.forEach(reportsData.rawData[sortInfo.index].detailGroups, data => {
     // sortInfo.sortBy = reportName === INSIGHT_360_DEMO_LABEL ? 'pct' : 'index';
      sortIndexInfo.push({
        label: data.brandLabel,
        value:
          sortInfo.sortBy === 'Index'
            ? data.index
            : _.toNumber(data.pct.replace('%', '')),
      });
    });
    sortedInfo = _.orderBy(sortIndexInfo, ['value'], [`${sortInfo.type}`]);
    _.forEach(sortedInfo, data => {
      categories.push(data.label);
    });
  } /* else {
    _.forEach(reportsData.rawData[0].detailGroups, data => {
      categories.push(data.label);
    });
  } */

  _.forEach(reportsData.rawData, data => {
    _.forEach(data.detailGroups, detail => {
      if (categories.indexOf(detail.brandLabel) === -1) {
        categories.push(detail.brandLabel);
      }
    });
    personas.push(data.label);
  });

  _.forEach(personas, (persona, i) => {
    const graphData = {};
    graphData.name = persona;
    graphData.data = [];
    _.forEach(categories, category => {
      let cat = {};
      cat = _.find(reportsData.rawData[i].detailGroups, {
        brandLabel: category,
      });

      if (typeof (cat) === 'undefined') {
        cat = {
          index: 0,
          pct: '0',
          sample: 0,
          weighted: 0,
        };
      }
      graphData.data.push({
        y:
          selectedIndex === 'Index'
            ? cat.index
            : _.toNumber(cat.pct.replace('%', '')),
        asterik: isMRISpecificStudy ? calculateMRIAsterisk(cat.sample, warningType) : calculateAsterisk(cat.sample),
        weighted: numberWithCommas(
          Math.round(cat.weighted),
        ),
        sample: numberWithCommas(
          Math.round(cat.sample),
        ),
        reach: cat.pct,
        indexVal: cat.index,
      });
    });
    graphSeriesData.push(graphData);
  });
  const totalDataPoints = categories.length * personas.length * 25;
  const height = totalDataPoints <= 400 ? '400px' : totalDataPoints;
  const config = {
    chart: {
      type: 'bar',
      height,
      spacingRight: 20,
    },
    annotations: [
      {
        labelOptions: {
          allowOverlap: true,
        },
      },
    ],
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    colors: REPORT_COLORS,
    xAxis: {
      categories,
      title: {
        text: null,
      },
      scrollbar: {
        enabled: true,
      },
    },
    yAxis: {
      min: 0,
      title: {
        // text: reportName === INSIGHT_360_DEMO_LABEL ? 'PERCENT' : reportsData.selectedIndex,
        text: (sortInfo.sortBy === 'pct' || sortInfo.sortBy === 'Percent') ? 'PERCENT' : reportsData.selectedIndex,
        align: 'high',
      },
      labels: {
        overflow: 'justify',
      },
      opposite: true,
    },
    /* tooltip: {
      valueSuffix: selectedIndex === 'Index' ? '' : '%',
    }, */
    tooltip: {
      borderRadius: 15,
      borderColor: 'rgb(212, 216, 221)',
      backgroundColor: '#fff',
      style: {
        fontSize: '11px',
      },
      formatter() {
        return `SAMPLE: <b>${this.point.sample}</b><br/>WEIGHTED: <b>${this.point.weighted}</b>
          <br/>${selectedIndex !== 'Index' ? `INDEX: <b>${this.point.indexVal}</b>` : 
          `REACH: <b>${this.point.reach}</b>`}`;
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: 'none',
          allowOverlap: true,
          formatter() {
            const pctOrIndex = selectedIndex === 'Index' ? '' : '%';
            return ` ${this.point.asterik} ${this.y}${pctOrIndex}`;
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    series: graphSeriesData,
  };
  return config;
};

export const checkReportDataAvailable = (reportData, fndIdx) => {
  let data;
  let dataIdx;
  if (!_.isEmpty(reportData)) {
    data = _.find(reportData, o => o.detailGroups.length > 0);
    dataIdx = _.findIndex(reportData, o => o.detailGroups.length > 0);
  }
  if (fndIdx) {
    return dataIdx;
  }
  return !_.isEmpty(data);
};


export const getFilterConfig = state => {
  let filterConfig = {};
  /* setting sample, pct from preferences */
  let pct = DEFAULT_REACH;
  let sample = DEFAULT_SAMPLE;
  let index = DEFAULT_INDEX;

  if (!_.isEmpty(state.insight360.bcSessionConfiguration)) {
    pct = state.insight360
      .bcSessionConfiguration[PREFERENCE_BRAND_CATALYST][PREFERENCE_BRAND_CATALYST_REACH];
    sample = state.insight360
      .bcSessionConfiguration[PREFERENCE_BRAND_CATALYST][PREFERENCE_BRAND_CATALYST_SAMPLE];
    index = state.insight360
      .bcSessionConfiguration[PREFERENCE_BRAND_CATALYST][PREFERENCE_BRAND_CATALYST_INDEX];
  }

  filterConfig = {
    sample: `>${sample}`,
    pct: `>${pct}`,
    index: formatIndexRangeFilter(index),
  };
  return filterConfig;
};

export const setBrandCatalystDataOnSave = (
  preferences,
  dispatch,
  getState,
  sessionPref = false) => {
  // Logic To Update study
  const { insight360studies, insight360study } = getState().study;
  if (insight360studies && insight360studies.length > 0) {
    const sessionConfigurationObject = _.cloneDeep(preferences);
    let getStudyObj;
    if (sessionPref) {
      getStudyObj = _.cloneDeep(insight360study);
    } else if (preferences[PREFERENCE_STUDY] === -1) {
      getStudyObj = _.cloneDeep(insight360studies[0].sl[0]);
    } else {
      getStudyObj = getStudyFromStudies(
        filterStudyList(_.cloneDeep(insight360studies), BRAND_CATALYST_FEATUREID),
        preferences[PREFERENCE_STUDY]
      );
    }
    Promise.all([
      dispatch(setPreferenceFlag('brandCatalyst', false)),
      dispatch(set360Study(getStudyObj)),
    ]).then(() => {
      // Logic To Update SalesCatalyst Reducer
      const { insight360 } = getState();
      const cloneBrandCatalystData = _.cloneDeep(insight360);
      _.forEach(_.keys(preferences), key => {
        if (key === PREFERENCE_BRAND_CATALYST_BASE) {
          preferences[key] = _.isEmpty(preferences[key]) ? undefined : {
            baseExpression: preferences[key][0].expression,
            baseLabel: preferences[key][0].label,
          };
        }
        // Storing the prefernces data to session object
        cloneBrandCatalystData.bcSessionConfiguration = { _bc: sessionConfigurationObject };
        const mappingObject = _.find(BRAND_CATALYST_PREFERENCE_KEY_MAPPING, { LABEL: key });
        if (mappingObject && !_.isEmpty(mappingObject)) {
          const { MAINCATEGORY, CATEGORY } = mappingObject;
          if (MAINCATEGORY !== '') {
            if (MAINCATEGORY === 'selectedFilters') {
              cloneBrandCatalystData[MAINCATEGORY][CATEGORY] = preferences[key];
              cloneBrandCatalystData.personaCreator[MAINCATEGORY][CATEGORY] = preferences[key];
              cloneBrandCatalystData.topMediaBrandSelectedFilters[CATEGORY] = preferences[key];
              cloneBrandCatalystData.personaCreator.topMediaBrandSelectedFilters[CATEGORY] = preferences[key];
            } else {
              cloneBrandCatalystData[MAINCATEGORY][CATEGORY] = preferences[key];
            }
          } else {
            cloneBrandCatalystData[CATEGORY] = preferences[key];
          }
        }
      });
      Promise.resolve(dispatch(setBrandCatalystPreferenceData(cloneBrandCatalystData)))
        .then(() => {
          dispatch(setPreferenceFlag('brandCatalyst', true));
        });
    });
  }
};

export const getStartIndex = data => {
   // setting index based on simmons and mri study
  const secondKey = Object.entries(data)[1][0];
  if (secondKey === PROFILE_SELF_CONCEPTS) {
    return 2;
  }
  return 1;
};


export const getOptions = attitudeData => {
  const options = [];
  if (attitudeData[0] !== undefined) {
    _.forEach(attitudeData[0].attitudeGroups, item => {
      _.forEach(item, (key, value) => {
        options.push(value);
      });
    });
  }
  return options;
};

export const validateSegmentScreenDisplay = personaCreator => {
  if (
    personaCreator.segments.segments !== undefined &&
    personaCreator.segments.segments.length === 3
  ) {
    const segmentsData = _.filter(
      personaCreator.segments.segments,
      segment => parseInt(segment.sample, 10) >= SAMPLE_SIZE_RESTRICTION,
    );

    return segmentsData.length === 3;
  }
  return false;
};

export const getBrandAndMediaFiltersFromPreferences = preferences => {
  let brandFilters = [];
  let mediaFilters = [];
  if (preferences && preferences.userPreferences && preferences.userPreferences[PREFERENCE_BRAND_CATALYST]) {
    brandFilters = _.cloneDeep(preferences.userPreferences[PREFERENCE_BRAND_CATALYST]
      [PREFERENCE_BRAND_CATALYST_BRAND_FILTER_LIST]);
    mediaFilters = _.cloneDeep(preferences.userPreferences[PREFERENCE_BRAND_CATALYST]
      [PREFERENCE_BRAND_CATALYST_MEDIA_FILTER_LIST]);
  }
  return { brandFilters, mediaFilters };
};


export const getsortByKeyBasedOnSelectedTab = (selectedTab, sortBykeyVal, pcSortByKey, btn) => {
  let sortBykey = '';
  if (selectedTab === INSIGHT360_EXPLORE) {
    sortBykey = sortBykeyVal;
  } else {
    sortBykey = pcSortByKey;
  }
  if (sortBykey === btn) {
    return '#485b74';
  }
  return '#91a2b9';
};


export const getSortByKey = (reportName, getState, isPersonaCreator, isProfileBrandAndMedia) => {
  let sortByKey = null;
  if (reportName === '360PROF' || isProfileBrandAndMedia) {
    sortByKey = isPersonaCreator !== true ? getState
    .insight360.sortByIndexAndReach[SECTION_SORT_BY_PROFILE] :
    getState.insight360.personaCreator
    .sortByIndexAndReach[SECTION_SORT_BY_PROFILE];
  }
  if (reportName === '360ATT') {
    sortByKey = isPersonaCreator !== true ? getState.insight360
    .sortByIndexAndReach[SECTION_SORT_BY_ATTITUDES] :
    getState.insight360.personaCreator
    .sortByIndexAndReach[SECTION_SORT_BY_ATTITUDES];
  }
  if (reportName === '360BRANDS' && isProfileBrandAndMedia !== true) {
    sortByKey = isPersonaCreator !== true ? getState.insight360
    .sortByIndexAndReach[SECTION_SORT_BY_BRANDS] :
    getState.insight360.personaCreator
    .sortByIndexAndReach[SECTION_SORT_BY_BRANDS];
  }
  if (reportName === '360MEDIA' && isProfileBrandAndMedia !== true) {
    sortByKey = isPersonaCreator !== true ? getState.insight360
    .sortByIndexAndReach[SECTION_SORT_BY_MEDIA] :
    getState.insight360.personaCreator
    .sortByIndexAndReach[SECTION_SORT_BY_MEDIA];
  }
  if (reportName === '360DEMOS') {
    sortByKey = isPersonaCreator !== true ? getState.insight360
    .sortByIndexAndReach[SECTION_SORT_BY_DEMOS] :
    getState.insight360.personaCreator
    .sortByIndexAndReach[SECTION_SORT_BY_DEMOS];
  }
  return sortByKey;
};

export const getDeepDiveSortByIndexAndReach = (deepdiveDetails,
 explorerKey, creatorKey) => {
  const section = _.lowerCase(deepdiveDetails.section);
  let sortByKey = null;
  sortByKey = deepdiveDetails.selectedTab === 'EXPLORE' ? explorerKey[section] :
    creatorKey[section];
  return sortByKey;
};


export const getDeepDiveSortByKey = (reportName, getState, selectedTab) => {
  let sortByKey = null;
  if (reportName === 'ATT') {
    sortByKey = selectedTab === 'EXPLORE' ? getState
      .insight360.sortByIndexAndReach[SECTION_SORT_BY_ATTITUDES] :
      getState.insight360.personaCreator
      .sortByIndexAndReach[SECTION_SORT_BY_ATTITUDES];
  }
  if (reportName === 'BRANDS') {
    sortByKey = selectedTab === 'EXPLORE' ? getState
      .insight360.sortByIndexAndReach[SECTION_SORT_BY_BRANDS] :
      getState.insight360.personaCreator
      .sortByIndexAndReach[SECTION_SORT_BY_BRANDS];
  }
  if (reportName === 'MEDIA') {
    sortByKey = selectedTab === 'EXPLORE' ? getState
      .insight360.sortByIndexAndReach[SECTION_SORT_BY_MEDIA] :
      getState.insight360.personaCreator
      .sortByIndexAndReach[SECTION_SORT_BY_MEDIA];
  }
  if (reportName === 'DEMOS') {
    sortByKey = selectedTab === 'EXPLORE' ? getState
      .insight360.sortByIndexAndReach[SECTION_SORT_BY_DEMOS] :
      getState.insight360.personaCreator
      .sortByIndexAndReach[SECTION_SORT_BY_DEMOS];
  }
  return sortByKey;
};

export const desOrderSortedArr = (allCategoriesList, sortBy) => {
  const sortIndexInfo = [];
  let sortedInfo = [];
  const sortedArr = [];
  _.forEach(allCategoriesList, data => {
    sortIndexInfo.push({
      label: data.label,
      value:
        sortBy === 'index'
          ? data.value.index
          : _.toNumber(data.value.pct.replace('%', '')),
    });
  });
   sortedInfo = _.orderBy(sortIndexInfo, ['value'], [`desc`]);
  _.forEach(sortedInfo, data => {
   const obj = _.find(allCategoriesList, ['label', data.label]);
   sortedArr.push(obj);
  });
  return sortedArr;
}


